export default __webpack_public_path__ + "static/media/puregases-temp.7f121713.JPG";